import { Query, QueryClient } from "@tanstack/react-query";
import { QueryOperation } from "./vlComponents";

export function deepMerge<T, U extends T>(target: T, source: U): U {
  const returnType = (target || {}) as U;
  for (const key in source) {
    if (source[key] instanceof Object)
      Object.assign(
        source[key] as any,
        deepMerge(returnType[key], source[key]),
      );
  }
  Object.assign(returnType || {}, source);
  return returnType;
}

export const getActiveQueryByOperationId = (
  queryClient: QueryClient,
  operationId: string,
): Query | undefined =>
  queryClient
    .getQueryCache()
    .findAll()
    .find((q) => q.getObserversCount() > 0 && q.queryKey[0] === operationId);

export const invalidateActiveQueryByOperationId = (
  queryClient: QueryClient,
  operationId: QueryOperation["operationId"],
) => {
  const activeQuery = getActiveQueryByOperationId(queryClient, operationId);
  if (activeQuery) {
    queryClient.invalidateQueries({ queryKey: activeQuery.queryKey });
  }
};
